<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner5.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">客户与联盟</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('WoMenDeKeHu')">我们的客户</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('HeZuoHuoBan')">2026合作伙伴计划</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('HeZuoJiGouYuGaoXiao')">合作机构与高校</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('KeHuYuLianMengView?id=14&customersType=604')">联盟与协会</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="article_list">
                        <ul>
                            <li v-for="(article, index) in article_list" :key="index" :id="article.id"><span class="title"><a href="javascript:void(0);" @click.stop="article_view(article.id,article.customersType)"><i class="icon icon_arrow"></i>{{ article.customersTitle }}</a></span><span class="date">{{ article.createDate }}</span></li>
                        </ul>
                    </div>
                    <div class="page">
                        <span>总共 {{ total_page }} 页，当前第 {{ pageNum }} 页</span>
                        <a href="javascript:void(0);" @click.stop="page('first')">首页</a>
                        <a href="javascript:void(0);" @click.stop="page('pre')" v-if="page_pre == 1">上一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">上一页</a>
                        <a href="javascript:void(0);" @click.stop="page('next')" v-if="page_next == 1">下一页</a>
                        <a href="javascript:void(0);" v-else class="nodata">下一页</a>
                        <a href="javascript:void(0);" @click.stop="page('last')">尾页</a>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { KeHuYuLianMeng } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '联盟与协会',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            article_list: '',

            customersType : 604,

            //翻页
            pageNum: 1, //当前页
            pageSize: 10, //每页显示数
            total : 0, //总数据

            total_page : '', //总页数
            page_pre : 0, //上一页
            page_next : 0, //下一页
            
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.KeHuYuLianMeng_data( this.customersType, this.pageNum, this.pageSize );
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        article_view( id, customersType) {  //带uuid跳转详情页面
            this.$router.push({
                path: "KeHuYuLianMengView",
                query: { id: id,customersType: customersType },
            });
        },
        page(e) {
            //分页参数
            if( e == "first" ){
                //首页
                this.KeHuYuLianMeng_data(
                    this.customersType,
                    1,
                    this.pageSize,
                );
            } else if ( e == "pre" ) {
                //上一页
                this.KeHuYuLianMeng_data(
                    this.customersType,
                    this.pageNum - 1,
                    this.pageSize,
                );
            } else if ( e == "next" ) {
                //下一页
                this.KeHuYuLianMeng_data(
                    this.customersType,
                    this.pageNum + 1,
                    this.pageSize,
                );
            } else if( e == "last" ){
                //尾页
                this.KeHuYuLianMeng_data(
                    this.customersType,
                    this.total_page,
                    this.pageSize,
                );
            };
        },
        KeHuYuLianMeng_data( customersType, pageNum, pageSize ){ //文章分类显示

            KeHuYuLianMeng({
                customersType : customersType , //分类
                pageNum : pageNum, //当前是第几页
                pageSize : pageSize, //每页显示多少条
            }).then((res) => {
                //console.log( res );
                this.article_list = res.rows;

                //翻页
                this.pageNum = pageNum; //当前页
                this.total = res.total; //总数据

                this.total_page = Math.ceil( res.total / this.pageSize );

                if( this.pageNum < this.total_page && this.pageNum == 1){
                    this.page_pre = 0;
                    this.page_next = 1;
                } else if ( this.pageNum == this.total_page && this.pageNum !== 1 ) {
                    this.page_pre = 1;
                    this.page_next = 0;
                } else if ( this.pageNum == this.total_page && this.total_page == 1 ) {
                    this.page_pre = 0;
                    this.page_next = 0;
                }else{
                    this.page_pre = 1;
                    this.page_next = 1;
                };

            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/LianMengYuXieHui.vue